import { useEffect, useState } from 'react';
import { Navigate, Outlet, useMatches } from 'react-router';

import { Center, Spinner, useToast } from '@chakra-ui/react';

import { STUDENT } from '../constants';
import { useAuth } from '../context/useAuth';
import Layout from '../components/layout';

interface RouteHandle {
  backPath?: string;
}

const UserRoute = () => {
  const { isAuthenticated, role, loading } = useAuth();
  const matches = useMatches();
  const toast = useToast();
  const [hasRedirected, setHasRedirected] = useState<boolean>(false);

  // fetch organizationCode from localStorage
  const organizationCode = localStorage.getItem('organizationCode');

  useEffect(() => {
    if (!isAuthenticated || (role !== STUDENT && !hasRedirected)) {
      if (!isAuthenticated) {
        return;
      }
      toast({
        position: 'top',
        title: 'アクセス権限がない',
        description: 'ページを表示する権限がありません。',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      setHasRedirected(true);
    }
  }, [isAuthenticated, role, hasRedirected, toast]);

  if (loading) {
    return (
      <Center height="100vh">
        <Spinner size="xl" color="#fca43b" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    const redirectRoute = `/login?organizationCode=${organizationCode}`;
    return <Navigate to={redirectRoute} replace />;
  }

  if (role !== STUDENT) {
    return <Navigate to="/students" replace />;
  }

  // Get the backPath from the current route's handle
  const currentRoute = matches[matches.length - 1];
  const backPath = (currentRoute?.handle as RouteHandle)?.backPath;

  return (
    <Layout backPath={backPath}>
      <Outlet />
    </Layout>
  );
};

export default UserRoute;
